import { create } from 'zustand';

type LeaderboardPanelStoreProps = {
	isOpen: boolean;
	onClose: () => void;
	onOpen: () => void;
	onToggle: () => void;
};

export const useLeaderboardPanelStore = create<LeaderboardPanelStoreProps>((set, get) => ({
	isOpen: false,
	onClose: () => set({ isOpen: false }),
	onOpen: () => set({ isOpen: true }),
	onToggle: () => set({ isOpen: !get().isOpen }),
}));

export const useLeaderboardPanel = () => useLeaderboardPanelStore((state) => state);
